var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 96,
    viewBox: "0 0 289 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 24.5,
    r: 13.5,
    fill: "#0077E6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 24.5,
    r: 13.5,
    fill: "#0077E6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.5,
    cy: 24.5,
    r: 13.5,
    fill: "#0077E6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 24.5,
    r: 13.5,
    fill: "#0077E6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 71.5,
    r: 13.5,
    fill: "#141414"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 71.5,
    r: 13.5,
    fill: "#DDDDDD"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.5,
    cy: 71.5,
    r: 13.5,
    fill: "#DDDDDD"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 71.5,
    r: 13.5,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 48H288",
    stroke: "#E4E4E4",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H286",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 95H286",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIllustration);
export default __webpack_public_path__ + "static/media/request_illustration.f97bb4d6d03358be4a27851513068166.svg";
export { ForwardRef as ReactComponent };